import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';
import { ComponentProps } from 'react';
import styled from 'styled-components';

import { LinkOther } from '@sorare/core/src/atoms/navigation/Box';
import { LabelS } from '@sorare/core/src/atoms/typography';
import { OpenItemDialogLink } from '@sorare/core/src/components/link/OpenItemDialogLink';
import { useSportContext } from '@sorare/core/src/contexts/sport';

import { AnyRewardConfig } from '../AnyRewardConfig';
import type { AnyCardReward_anyCardReward } from './__generated__/index.graphql';

const StyledLabelS = styled(LabelS)`
  max-width: 110px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

type Props = {
  anyCardReward: AnyCardReward_anyCardReward;
} & Pick<
  ComponentProps<typeof AnyRewardConfig>,
  'rarity' | 'variant' | 'size' | 'count'
>;

export const AnyCardReward = ({
  anyCardReward,
  ...anyRewardConfigProps
}: Props) => {
  const { sport } = useSportContext();

  return (
    <LinkOther as={OpenItemDialogLink} item={anyCardReward.card} sport={sport}>
      <AnyRewardConfig
        anyRewardConfig={anyCardReward.config}
        {...anyRewardConfigProps}
      >
        <StyledLabelS bold>
          {anyCardReward.card.anyPlayer.displayName}
        </StyledLabelS>
      </AnyRewardConfig>
    </LinkOther>
  );
};

AnyCardReward.fragments = {
  anyCardReward: gql`
    fragment AnyCardReward_anyCardReward on AnyCardReward {
      id
      card {
        slug
        anyPlayer {
          slug
          displayName
        }
      }
      config {
        id
        ...AnyRewardConfig_anyRewardConfigInterface
      }
    }
    ${AnyRewardConfig.fragments.anyRewardConfigInterface}
  ` as TypedDocumentNode<AnyCardReward_anyCardReward>,
};
